module.exports = __webpack_public_path__ + "static/media/gmail-reply.cbdb25c4.png";